import React, { useEffect, useRef } from "react";
import { Animated, StyleSheet, TouchableOpacity, View } from "react-native";
import { Feather } from "@expo/vector-icons";
import { useRouter } from "expo-router";

interface LockButtonProps {
  hasPendingRequests: boolean;
}

function LockIcon({ hasPendingRequests }: LockButtonProps): React.JSX.Element {
  const router = useRouter();
  const opacity = useRef(new Animated.Value(1)).current;

  useEffect(() => {
    if (hasPendingRequests) {
      Animated.sequence([
        Animated.timing(opacity, {
          duration: 1000,
          toValue: 0, // Longer duration for fading out
          useNativeDriver: true,
        }),
        Animated.timing(opacity, {
          duration: 1000,
          toValue: 1, // Longer duration for fading in
          useNativeDriver: true,
        }),
      ]).start();
    }
  }, [hasPendingRequests]);

  const handlePermPress = (): void => {
    router.push({
      pathname: "/(main)/media/permissions",
    });
  };

  return (
    <View style={styles.iconsContainer}>
      <TouchableOpacity
        style={styles.iconButton}
        onPress={() => handlePermPress()}
      >
        <Feather name="lock" size={24} color="black" />
        {hasPendingRequests && (
          <Animated.View style={[styles.pendingIndicator, { opacity }]} />
        )}
      </TouchableOpacity>
    </View>
  );
}

const styles = StyleSheet.create({
  iconButton: {
    marginHorizontal: 5,
    position: "relative",
  },
  iconsContainer: {
    flexDirection: "row",
  },
  pendingIndicator: {
    backgroundColor: "red",
    borderRadius: 4,
    height: 8,
    position: "absolute",
    right: 2,
    top: 2,
    width: 8,
  },
});

export default LockIcon;
